import { ActivityBlock } from '../../abstract/ActivityBlock.js';

export class ActivityHeader extends ActivityBlock {}
